export default __webpack_public_path__ + "static/media/wow.e2d65668.wav";